import {CSSProperties, FC} from 'react';


export interface IIconToolsProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconTools: FC<IIconToolsProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M6.846 5.162a2.777 2.777 0 0 1 3.548 3.55L19 17.317 17.316 19l-8.605-8.604a2.777 2.777 0 0 1-3.549-3.55L6.936 8.62A1.19 1.19 0 1 0 8.62 6.937L6.845 5.161Zm8.226 1.495 2.525-1.403 1.122 1.122L17.316 8.9l-1.403.28-1.682 1.684-1.123-1.123 1.683-1.683.281-1.402Zm-5.61 6.171 1.682 1.684-3.928 3.928a1.19 1.19 0 0 1-1.759-1.599l.077-.085 3.928-3.928Z" clipRule="evenodd" />
        </svg>
    );
};
